import React, { useMemo } from 'react';
import { IonInput, IonItem, IonLabel, IonList } from '@ionic/react';
import { uiInputMode } from '../../utils/ui';
import { useTranslation } from 'react-i18next';
import { AccountSecurityQuestion } from '../../services/types/apitypes';
import { cfgSecurityQuestionLength } from '../../utils/config';
import './QuestionsForm.css';

type QuestionsFormProps = {
  toQuestions: (position: number) => void;
  securityQuestions: AccountSecurityQuestion[];
  setAnswers: (answer: string, position: number) => void;
};

export default function QuestionsForm({
  toQuestions,
  securityQuestions,
  setAnswers,
}: QuestionsFormProps): JSX.Element {
  const [t] = useTranslation('global');

  const questionsLength = useMemo(() => cfgSecurityQuestionLength(), []);

  const questions = Array.from(Array(questionsLength).keys()).map((i) => (
    <IonList key={`security-question-${i}`} className={i !== 0 ? 'questionform-list' : ''}>
      <IonItem
        onClick={() => toQuestions(i)}
        lines="none"
        className="ion-no-padding ion-pt-1 pseudo-select"
        button={true}
        detail={true}
      >
        <IonLabel>
          {securityQuestions?.[i]?.questionText || (
            <>{t('register.securityselect')}</>
          )}
        </IonLabel>
      </IonItem>
      <IonItem lines="none" className="ion-no-padding ion-pt-1">
        <IonInput
          value={securityQuestions?.[i]?.answer || ''}
          mode={uiInputMode()}
          aria-label={t('register.securityanswer')!}
          placeholder={t('register.securityanswer')!}
          onIonInput={(e) => setAnswers(e.detail.value!, i)}
          type="text"
          fill="outline"
        />
      </IonItem>
    </IonList>
  ));

  return <>{questions}</>;
}
